import {
  LINKEDIN_ENTITY_URL_REGEX,
  LinkedInAnnotation,
} from '../LinkedInAnnotations'
import type { LinkedInAnnotationEntityDetails } from '../nodes'

/**
 * A pasted LinkedIn company/school/showcase URL resolves directly to one
 * entity — unlike a profile URL, which just seeds a real search (see
 * getNewSuggestionsOnMentionUpdate). Returns `null` when `text` isn't a
 * LinkedIn entity URL at all (not this flow's concern), or the resolved
 * entity, or `undefined` if the URL matched the shape but no entity was
 * found for it.
 */
export async function resolveLinkedInEntityUrl(
  text: string,
  channelId: string,
): Promise<LinkedInAnnotationEntityDetails | undefined | null> {
  if (!LINKEDIN_ENTITY_URL_REGEX.test(text)) return null

  return LinkedInAnnotation.getLinkedInEntityDetails(text, channelId)
}
